import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { noOp, getClassNames } from '../../../../utils/util';

import ProductFilterContainer from '../../../../containers/common/product-filter/ProductFilter.container';
import ProductListing from '../../../common/listing/product-listing/ProductListing';

import { ReactComponent as StarEmptyIcon } from '../../../../resources/icons/star-empty.svg';

import './featured-listings.scss';

const FeaturedListings = ({ listings }) => {
  const [miniView, setMiniView] = useState(true);

  const navigate = useNavigate();

  const renderListings = () => {
    const actions = (
      <>
        <button className={getClassNames('featured-listings__button', { mini: miniView })} onClick={noOp}>
          Bookmark This
          <StarEmptyIcon data-testid="star-empty-icon" />
        </button>
        <button className={getClassNames('featured-listings__button', { mini: miniView })} onClick={noOp}>
          View Product Page <p>{'>'}</p>
        </button>
      </>
    );

    return listings.map((listing) => (
      <ProductListing key={listing.productExternalReference} listing={listing} actions={actions} mini={miniView} />
    ));
  };

  return (
    <section className="featured-listings">
      <ProductFilterContainer onApplyFiltersClick={noOp} />

      <section className="featured-listings__listings">
        <section>
          <h1>Featured Listings</h1>
          <div className={getClassNames('featured-listings__header-buttons', { mini: miniView })}>
            <button onClick={() => setMiniView(!miniView)}>Switch View</button>
            <button onClick={() => navigate('/shop/upload-product-listing')}>
              <span />
              Upload New
            </button>
          </div>
        </section>
        {miniView && (
          <section className="featured-listings__mini-headers">
            <p>Product</p>
            <p>Price/Product Unit</p>
            <p>Available Date</p>
            <span />
          </section>
        )}
        <section>{renderListings()}</section>
      </section>
    </section>
  );
};

FeaturedListings.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({})),
};

FeaturedListings.defaultProps = {
  listings: [],
};

export default FeaturedListings;
